import React from 'react'
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./Clients.css";
import { Button } from "@mui/material";

export const TextEditor = ({client_id, editorState,setEditorState,isEditable, setIsEditable}) => {

  return (
    <>
    <Button onClick={()=>{setIsEditable(true)}}>Edit</Button>
      <Editor
        editorState={editorState}
        toolbarHidden ="true"
        readOnly="true"
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
      />
    </>
  )
}
